import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	en: {
		translation: {
			'Welcome to React': 'Welcome to React and react-i18next'
		}
	}
};

let userLang = (navigator.language || navigator.userLanguage).toLowerCase();
const lngList = ['en', 'tw', 'ch'];
let lng = localStorage.getItem('lng') || lngList[0];

if (localStorage.getItem('lng') === null) {
	// https://www.localeplanet.com/icu/
	if (userLang.includes('zh')) {
		if (userLang.includes('tw')) {
			lng = 'tw';
		} else {
			lng = 'ch';
		}
	}
}

i18n.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		resources,
		lng: lng,

		keySeparator: false, // we do not use keys in form messages.welcome

		interpolation: {
			escapeValue: false // react already safes from xss
		}
	});

export default i18n;
